<script>
  import BookList from './BookList.svelte';
  import { user, book_lists, genres } from './stores.js';

  export let category;


  import { onMount } from "svelte";

  onMount(() => {
    window.scrollTo(0, 0);
  });
</script>

<style>
  main {
    padding: 50px 60px;
  }

  .sorters {
    text-align: right;
  }

  .sort {
    display: inline-block;
    padding: 5px 10px;
    font-weight: 600;
    font-size: 14px;

  }
  .sort.active {
    padding: 5px 20px;
    color: #FFF;
    background: #ec6a33;
    border-radius: 5px;
    margin-left: 10px;
  }
</style>

<main>
  <h1>{category}</h1>

  <div class="sorters">
    Sort by 
    <a href="#" class="sort active">Rating ↓</a>
    <a href="#" class="sort">Publication date ↓</a>
    <a href="#" class="sort">Title ↓</a>
    <a href="#" class="sort">Author ↓</a>
  </div>

  <BookList books={book_lists.new} />
</main>
